import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=96d4e6ec"
import script from "./Servicos.vue?vue&type=script&lang=js"
export * from "./Servicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports